var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alpheios-wordlist-sorting" },
    _vm._l(_vm.sortingFields, function (field, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "alpheios-worditem__data alpheios-worditem__icon",
          class: _vm.fieldClass(field.name),
          on: {
            click: function ($event) {
              return _vm.changeSort(field.name)
            },
          },
        },
        [
          field.sorting
            ? _c("sort-icon", {
                class: {
                  "alpheios-icon-asc": _vm.sortingState[field.name] === "asc",
                  "alpheios-icon-desc": _vm.sortingState[field.name] === "desc",
                },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }